import { Injectable } from '@angular/core'
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { MbConstants } from '../../../shared/mb-constants'
import { MbEventListenerService } from '../mb-event-listener/event-listener.service'
import { UcElementBlockedEvent } from '../../components/shared/events/uc-element-blocked-event'
import { UcManagementService } from '../usercentrics-consent-manager/uc-management.service'
import { switchMap } from 'rxjs/operators'
import { CmsHttpStatusCode } from '../../enums/cms-http-status-code'
import { UcService } from '../../enums/uc-service'

@Injectable({ providedIn: 'root' })
export class HttpRequestInterceptorService implements HttpInterceptor {

  constructor (private eventListenerService: MbEventListenerService,
               private ucManagement: UcManagementService) {
  }

  intercept (req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    const ucId = req.headers.get(MbConstants.UC_ID)
    const ucService = req.headers.get(MbConstants.UC_SERVICE) as UcService
    if (!ucId || !ucService) {
      return next.handle(req)
    }
    return this.ucManagement.shouldRequestBeBlocked(ucService, req.url).pipe(
      switchMap(shouldRequestBeBlocked => {
        if (!shouldRequestBeBlocked) {
          const modifiedReq = req.clone({
            headers: req.headers
              .delete(MbConstants.UC_ID)
              .delete(MbConstants.UC_SERVICE)
          })
          return next.handle(modifiedReq)
        }
        this.eventListenerService.update(new UcElementBlockedEvent(ucId as string, ucService))
        return throwError(new HttpErrorResponse({
          status: CmsHttpStatusCode.BLOCKED_BY_COOKIE_CONSENT,
          statusText: 'Request blocked by cookie settings.'
        }))
      })
    )
  }
}
